/**
 * @desc 出库单导出
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.outMaster.exporting.Params, options?: any) {
  return updateResponse(
    http(URL + `/outMaster/export`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
